import { Injectable } from "@angular/core";
import { SpecificationEtapeMaster } from "../models/specification-etape.model";
import { EntityStoreService } from "../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../shared/store/store-types.model";
import { SpecificationFacadeService } from "./specification-facade.service";
import { SpecifModifs } from "../models/specif_modifs.model";
import { EtapePath, EtapePathDoer } from "../models/etape-path.model";

@Injectable({ providedIn: "root" })
export class SpecificationStoreService extends EntityStoreService<
  SpecificationEtapeMaster,
  EntityMetadata,
  SpecificationState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      sem: null,
      specifModif: [],
      selectedSpecificationEtapeId: null,
      articlePaths: null,
      editing: false,
    });
  }
}

export interface SpecificationState
  extends EntityStoreState<SpecificationFacadeService> {
  sem: SpecificationEtapeMaster;
  specifModif: SpecifModifs[];
  selectedSpecificationEtapeId: string;
  editing: boolean;
  articlePaths: {
    etapePath: EtapePath;
    etapePathDoer: EtapePathDoer;
  };
}
